export type FernieFaceState = "rest" | "listening" | "thinking" | "working" | "done" | "straight";

export type FernieMark = "face" | "micro" | "eyes";

export type FernieMicroVariant = "smile" | "eyes";

export const FERNIE_MIN_SIZE = {
	eyes: 16,
	face: 32,
	lockup: 64,
	micro: 20
} as const;

export function resolveFernieMark(size: number): FernieMark {
	if (size >= FERNIE_MIN_SIZE.face) return "face";
	if (size >= FERNIE_MIN_SIZE.micro) return "micro";
	return "eyes";
}

export function resolveMicroVariant(size: number): FernieMicroVariant {
	return size < FERNIE_MIN_SIZE.micro ? "eyes" : "smile";
}

export function clampMarkSize(mark: keyof typeof FERNIE_MIN_SIZE, size: number): number {
	return Math.max(size, FERNIE_MIN_SIZE[mark]);
}
